<template>
    <div class="aqualina-flats">
        <div class="container">
            <div class="flats-navigation" v-if="salesCard.project_land_site.flats_nav_init == 'true'">
                <ul>
                    <li v-for="(item, index) in salesCard.project_land_site.flats_nav" :key="index" :class="{'active' : activeFlats == item.id}">
                        <a :href="item.id" @click.prevent="changeActiveFlatsClass(item.id)">{{item.name}}</a>
                    </li>
                </ul>
            </div>
            <div class="plans-villa" v-if="activeFlats == 'villa'">
                <div class="plans-items">
                    <div class="item" v-for="(item, index) in salesCard.villa" @click.prevent="settingDataFlatsCardModal(item)">
                        <div class="item-title">
                            <h3>{{item.name}}</h3>
                            <h4><span class="title">Общая площадь:</span>{{item.villa_size}} <span>м²</span></h4>
                        </div>
                        <div class="item-pics">
                            <div class="left">
                                <div class="item-img">
                                    <img :src="item.first_floor_img" alt="">
                                </div>
                                <div class="info">
                                    <div class="col">
                                        <h3>1</h3>
                                        <small>Этаж</small>
                                    </div>
                                    <div class="col">
                                        <h3>{{item.first_floor_size}}</h3>
                                        <small>площадь<span>м²</span></small>
                                    </div>
                                </div>
                            </div>
                            <div class="right">
                                <div class="item-img">
                                    <img :src="item.second_floor_img" alt="">
                                </div>
                                <div class="info">
                                    <div class="col">
                                        <h3>2</h3>
                                        <small>Этаж</small>
                                    </div>
                                    <div class="col">
                                        <h3>{{item.second_floor_size}}</h3>
                                        <small>площадь<span>м²</span></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="plans-house" v-if="activeFlats == 'house'">
                <div class="plans-items">
                    <div class="item" v-for="(item, index) in salesCard.taun_flats" @click.prevent="settingDataFlatsCardModal(item)">
                        <div class="item-title">
                            <h3>{{item.name}}</h3>
                            <h4><span class="title">Общая площадь:</span>{{item.villa_size}} <span>м²</span></h4>
                        </div>
                        <div class="item-pics">
                            <div class="column left">
                                <div class="item-img">
                                    <img :src="item.first_floor_img" alt="">
                                </div>
                                <div class="info">
                                    <div class="col">
                                        <h3>1</h3>
                                        <small>Этаж</small>
                                    </div>
                                    <div class="col">
                                        <h3>{{item.first_floor_size}}</h3>
                                        <small>площадь<span>м²</span></small>
                                    </div>
                                </div>
                            </div>
                            <div class="column center">
                                <div class="item-img">
                                    <img :src="item.second_floor_img" alt="">
                                </div>
                                <div class="info">
                                    <div class="col">
                                        <h3>2</h3>
                                        <small>Этаж</small>
                                    </div>
                                    <div class="col">
                                        <h3>{{item.second_floor_size}}</h3>
                                        <small>площадь<span>м²</span></small>
                                    </div>
                                </div>
                            </div>
                            <div class="column right">
                                <div class="item-img">
                                    <img :src="item.third_floor_img" alt="">
                                </div>
                                <div class="info">
                                    <div class="col">
                                        <h3>3</h3>
                                        <small>Этаж</small>
                                    </div>
                                    <div class="col">
                                        <h3>{{item.third_floor_size}}</h3>
                                        <small>площадь<span>м²</span></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="plans-flats" v-if="activeFlats == 'flats'">
                <aqualinaApartments></aqualinaApartments>
            </div>
        </div>
        <!-- модалка планировки -->
        <modal name="aqualina_land_flat-card-modal" @opened="FlatCardModalOpened" @closed="FlatCardModalClosed" :transition="transitionName" :width="modalWidth" :height="modalHeight" :scrollable="modalScroll" id="aqualina_land_flat_card_modal_window_info" v-if="modalData != null">
            <flatModal :config="[{active: formActive, mobile: mobile}]"></flatModal>
        </modal>
        <!-- end -->
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    import flatModal from '@/components/sales-land-partials/partials/aqualina-flats-modal.vue'
    import aqualinaApartments from '@/components/sales-land-partials/partials/aqualina-flats-partials/flat-main.vue'
    export default {
        name: 'sales-aqualina-flats',
        components: {
            flatModal,
            aqualinaApartments,
        },
        data () {
            return {
                modalWidth: 1000,
				modalHeight: 640,
				modalScroll: false,
				formActive: false,
				mobile: false,
				transitionName: '',
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            modalData: 'loadSalesLandModalDataArr',
            activeFlats: 'loadActiveFlatsClass',
        }),
        methods: {
            settingDataFlatsCardModal(arr) {
				
				this.$store.commit('modalData', arr);
                console.log(this.modalData)
				this.$modal.show('aqualina_land_flat-card-modal');
				// this.$store.commit('Open_Form_Modal', false);
				// document.getElementById('secret-btns').classList.remove('fadeIn');
			},
            FlatCardModalClosed() {
				// this.formActive = false;
				window.body.removeClass('overflowTrue');
				// document.getElementById('secret-btns').classList.remove('hideAll');
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('landNav').classList.remove('notvisibleSalesLand');
                // document.getElementById('banerTopHorizont').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
			},
			FlatCardModalOpened() {
				window.Sharer.init();
				window.body.addClass('overflowTrue');
				// document.getElementById('secret-btns').classList.add('hideAll');
				document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('landNav').classList.add('notvisibleSalesLand');
                // document.getElementById('banerTopHorizont').classList.add('notvisibleSalesLand');
                document.getElementById('footer').classList.add('notvisibleSalesLand');
			},
            changeActiveFlatsClass(data) {
                this.$store.commit('changeActiveFlatsClass', data);
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/partials/aqualina-flats.scss';
    @import '@/styles/respond/sales/sales-land-partials/partials/aqualina-flats-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-about-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>